import React, { useState, useEffect } from "react";
import { FiX, FiChevronDown, FiChevronUp } from "react-icons/fi";
import { PiSlidersHorizontal } from "react-icons/pi";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { SlArrowDown, SlArrowUp } from "react-icons/sl";
import { CiDiscount1 } from "react-icons/ci";
import { FiTruck } from "react-icons/fi";
import { PiShoppingCartLight } from "react-icons/pi";
import { MdOutlineStarPurple500 } from "react-icons/md";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { addToWishlist, removeFromWishlist, getWishlistProducts } from "../../utils/wishlistUtils";
import ReactSlider from "react-slider";
import { addToCart, getCartCount } from "../../utils/cartUtils";
import Login from "../Layout/Login/Login";


const ProductList12 = ({
  data,
  totalItems,
  subcategoryName,
  isReset,
  fetchNextPage,
  hasMore,
  isFetching,
  onResetFilters,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  const [favorites, setFavorites] = useState({});
  const [filters, setFilters] = React.useState([]);
  const [sliderValues, setSliderValues] = React.useState({});
  const [selectedOptions, setSelectedOptions] = useState({
    expandedSections: {}, // To track which filter sections are open
  });

  const [isLoading, setIsLoading] = useState(false);
  const [vibratingHearts, setVibratingHearts] = useState({});
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const openLoginModal = () => setIsLoginModalOpen(true);
  const closeLoginModal = () => setIsLoginModalOpen(false);
  const [vibratingCarts, setVibratingCarts] = useState({});
  const [webFont, setWebFont] = useState("");
  const [themeColor, setThemeColor] = useState("");
  const [sortOption, setSortOption] = useState(""); // Default sort option

  const [maxPrice, setMaxPrice] = useState(0);
  const [priceRange, setPriceRange] = useState([1000, 0]);
  const [cartMessages, setCartMessages] = useState({});
  const [mainCategoryId, setMainCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");

  //  CHECK IF ANY FILTER IS APPLIED
  const isFilterApplied = Object.keys(selectedOptions).some(
    (key) =>
      key !== "expandedSections" &&
      selectedOptions[key] &&
      selectedOptions[key].length > 0
  );

  //  DECIDE WHICH COUNT TO SHOW
  const displayCount = isFilterApplied ? products.length : totalItems;


  //  Utility function to calculate highest product price
  const calculateMaxPrice = (products) => {
    if (!products || products.length === 0) return 0;

    const prices = products
      .map(p => {
        // price is like "₹1234"
        if (!p.price) return 0;
        return Number(p.price.replace("₹", ""));
      })
      .filter(price => price > 0);

    return prices.length > 0 ? Math.max(...prices) : 0;
  };
  useEffect(() => {
    if (products.length === 0) return; // Skip if no products

    const sortedProducts = [...products]; // Create a copy to avoid mutating state

    switch (sortOption) {
      case "Price: Low to High":
        sortedProducts.sort((a, b) => {
          const priceA = parseFloat(a.price.replace("₹", ""));
          const priceB = parseFloat(b.price.replace("₹", ""));
          return priceA - priceB;
        });
        break;

      case "Price: High to Low":
        sortedProducts.sort((a, b) => {
          const priceA = parseFloat(a.price.replace("₹", ""));
          const priceB = parseFloat(b.price.replace("₹", ""));
          return priceB - priceA;
        });
        break;

      case "New Arrivals":
        sortedProducts.sort((a, b) => {
          // Prioritize products with badge "New Arrival"
          if (a.badge === "New Arrival" && b.badge !== "New Arrival") return -1;
          if (a.badge !== "New Arrival" && b.badge === "New Arrival") return 1;
          return 0; // Maintain order if both are same
        });
        break;

      case "Discounts":
        sortedProducts.sort((a, b) => {
          const discountA = a.discount === "No discount" ? 0 : parseFloat(a.discount.replace("% off", ""));
          const discountB = b.discount === "No discount" ? 0 : parseFloat(b.discount.replace("% off", ""));
          return discountB - discountA; // Higher discount first
        });
        break;

      default:
        break;
    }

    setProducts(sortedProducts); // Update state with sorted products
  }, [sortOption, products.length]); // Depend on sortOption and products.length


  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setWebFont(parsedStyle.web_font);
      setThemeColor(parsedStyle.web_theme_colour)
    }
  }, []);

  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }




  const toggleDropdown = () => {
    setIsOpen2((prev) => !prev);
  };

  const toggleDropdown2 = () => {
    setIsOpen3((prev) => !prev);
  };


  const mapProductData = (data1) => {
    const baseUrl =
      "https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/";

    return data1.map((product, index) => ({
      id: index + 1,
      product_auto_id: product.product_auto_id,
      name: product.product_name || "Unknown Product",
      features: product.description
        ? [product.description]
        : ["No description available"],
      price: `₹${product.final_product_price || "0"}`,
      originalPrice: `₹${product.product_price || "0"}`,
      discount: product.offer_percentage
        ? `${product.offer_percentage}% off`
        : "No discount",
      image:
        product.product_images?.length > 0
          ? `${baseUrl}${product.product_images[0].product_image}`
          : "default-image.jpg",
      badge: product.new_arrival?.toLowerCase() === "yes" ? "New Arrival" : "",
      bought: `${product.bought_count}+ Bought`,
      delivery: `${product.time} ${product.time_unit}`,
      rating: product.avg_rating || 0,
    }));
  };

  // useEffect(() => {
  //   if (data) {
  //     const mappedProducts = mapProductData(data);
  //     setProducts((prev) => {
  //       if (isReset) {
  //         return mappedProducts;
  //       } else {
  //         const existingIds = new Set(prev.map(p => p.product_auto_id));
  //         const newProducts = mappedProducts.filter(p => !existingIds.has(p.product_auto_id));
  //         return [...prev, ...newProducts];
  //       }
  //     });
  //   }
  // }, [data]);
  useEffect(() => {
     if (Array.isArray(data) && data.length > 0) {

      setMainCategoryId(data[0].main_category_auto_id || "");
      setSubCategoryId(data[0].sub_category_auto_id || "");
      const mappedProducts = mapProductData(data);

      setProducts((prev) => {
        const finalProducts = isReset
          ? mappedProducts
          : [
            ...prev,
            ...mappedProducts.filter(
              p => !prev.some(prevP => prevP.product_auto_id === p.product_auto_id)
            ),
          ];

        //  STEP 3.1: calculate highest price
        const highestPrice = calculateMaxPrice(finalProducts);

        //  STEP 3.2: update price states
        setMaxPrice(highestPrice);
        setPriceRange([1000, highestPrice]);

        return finalProducts;
      });
    }
  }, [data, isReset]);

  const syncWishlist = async (productList) => {
    const token = sessionStorage.getItem("accessToken");
    if (!token || !Array.isArray(productList)) return;

    try {
      const wishlist = await getWishlistProducts();

      const wishlistSet = new Set(
        wishlist.map((w) => String(w.product_auto_id))
      );

      const updatedFavorites = {};
      productList.forEach((product) => {
        updatedFavorites[product.id] = wishlistSet.has(
          String(product.product_auto_id)
        );
      });

      setFavorites(updatedFavorites);
    } catch (error) {
      console.error("Wishlist sync failed:", error);
    }
  };
  useEffect(() => {
    if (products.length > 0) {
      syncWishlist(products);
    }
  }, [products]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 1500 &&
        !isFetching &&
        hasMore
      ) {
        fetchNextPage(); // ← This comes from props
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [fetchNextPage, isFetching, hasMore]);

  const toggleFavorite = async (id, productId) => {
    const customerId = sessionStorage.getItem("accessToken");
    if (!customerId) {
      // Trigger vibration on the heart icon
      setVibratingHearts((prev) => ({ ...prev, [id]: true }));
      setTimeout(() => {
        setVibratingHearts((prev) => ({ ...prev, [id]: false }));
        openLoginModal(); // Open login modal after vibration
      }, 500); // Vibration duration
      return;
    }

    const isNowFavorite = !favorites[id];
    setFavorites((prev) => ({
      ...prev,
      [id]: isNowFavorite,
    }));

    try {
      if (isNowFavorite) {
        await addToWishlist(productId);
      } else {
        await removeFromWishlist(productId);
      }
    } catch (error) {
      console.error("Error toggling wishlist:", error);
      setFavorites((prev) => ({ ...prev, [id]: !isNowFavorite }));
      setVibratingHearts((prev) => ({ ...prev, [id]: true }));
      setTimeout(() => {
        setVibratingHearts((prev) => ({ ...prev, [id]: false }));
      }, 500);
    }


  };

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_filter_menu`,
          {
            admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          }
        );

        if (response.data?.status === 1) {
          const data2 = response.data;

          const priceRange = {
            min: 0,
            max: maxPrice > 0 ? maxPrice : 1000,
          };


          const apiFilters = data2.allfiltermenus.map(
            (filter) => filter.filter_menu_name
          );

          const updatedFilters = apiFilters.map((apiFilter) => {
            let options = [];
            let type = "checkbox";
            let sliderRange = null;

            switch (apiFilter) {
              case "Price":
                type = "slider";
                sliderRange = priceRange;
                break;

              case "Thickness":
                type = "slider";
                break;

              case "Manufacturers":
                options =
                  data2.manufacturer_list?.map((item) => ({
                    label: item.manufacturer_name,
                    value: item._id,
                  })) || [];
                break;

              case "Size":
                options =
                  data2.size_list?.map((item) => ({
                    label: item.size,
                    value: item.size_auto_id,
                  })) || [];
                break;

              case "Brand":
                options =
                  data2.brand_list?.map((item) => ({
                    label: item.brand_name,
                    value: item.brand_auto_id,
                  })) || [];
                break;

              case "Color":
                options =
                  data2.color_list?.map((item) => ({
                    label: item.color_name,
                    value: item._id,
                  })) || [];
                break;

              case "Material":
                options =
                  data2.material_list?.map((item) => ({
                    label: item.material_name,
                    value: item._id,
                  })) || [];
                break;

              case "Discount":
                options =
                  data2.discount_list?.map((item) => ({
                    label: `${item.discount_percent}%`,
                    value: item._id,
                  })) || [];
                break;

              case "Firmness":
                options =
                  data2.firmness_list?.map((item) => ({
                    label: item.unit,
                    value: item._id,
                  })) || [];
                break;

              case "Out of stock":
                options = [{ label: "Include out of stock", value: true }];
                break;

              case "Moq":
                options = Array.from({ length: 10 }, (_, i) => ({
                  label: (i + 1).toString(),
                  value: i + 1,
                }));
                break;

              default:
                options = [];
            }

            return {
              title: apiFilter,
              type,
              options,
              sliderRange,
            };
          });

          const dimensionInApi = apiFilters.some(
            (name) => name.toLowerCase() === "dimension"
          );

          if (dimensionInApi) {
            const cleanedFilters = updatedFilters.filter(
              (f) => f.title.toLowerCase() !== "dimension"
            );

            cleanedFilters.push({
              title: "Dimension",
              type: "dimension-group",
              options: [
                { name: "Height", type: "slider" },
                { name: "Width", type: "slider" },
                { name: "Depth", type: "slider" },
              ],
            });

            setFilters(cleanedFilters);
          } else {
            setFilters(updatedFilters);
          }
        }
      } catch (error) {
        console.error("Error fetching filters:", error);
      }
    };

    if (maxPrice > 0) {
      fetchFilters();
    }
  }, [maxPrice]);

  React.useEffect(() => {
    if (filters.length > 0) {
      const initialValues = {};
      filters.forEach((filter) => {
        if (filter.type === "slider" && filter.sliderRange) {
          initialValues[filter.title] = [
            filter.sliderRange.min,
            filter.sliderRange.max,
          ];
        }
        if (filter.type === "dimension-group") {
          filter.options.forEach((dim) => {
            initialValues[dim.name] = [0, 100];
          });
        }
      });
      setSliderValues(initialValues);
    }
  }, [filters]);




  const applyFilters = async () => {
    setIsLoading(true);
    const admin_auto_id = sessionStorage.getItem("admin_auto_id");
    const app_type_id = sessionStorage.getItem("app_type_id");
    const user_auto_id =
      sessionStorage.getItem("accessToken") ||
      sessionStorage.getItem("admin_auto_id");
    const country = localStorage.getItem("country_name") || "India";

    const formData = new FormData();
    formData.append("admin_auto_id", admin_auto_id);
    formData.append("app_type_id", app_type_id);
    formData.append("customer_auto_id", user_auto_id);
    formData.append("country", country);
    formData.append("limit", 10);
    formData.append("page_number", 1);
    formData.append("main_category_id", mainCategoryId);
    formData.append("sub_category_id", subCategoryId);


    Object.entries(selectedOptions).forEach(([key, value]) => {
      if (
        value?.min !== undefined &&
        value?.max !== undefined &&
        key !== "expandedSections"
      ) {
        switch (key) {
          case "Price":
            formData.append("min_price", value.min);
            formData.append("max_price", value.max);
            break;
          case "Thickness":
            formData.append("min_thickness", value.min);
            formData.append("max_thickness", value.max);
            break;
          case "Dimension-Height":
            formData.append("min_height", value.min);
            formData.append("max_height", value.max);
            break;
          case "Dimension-Width":
            formData.append("min_width", value.min);
            formData.append("max_width", value.max);
            break;
          case "Dimension-Depth":
            formData.append("min_depth", value.min);
            formData.append("max_depth", value.max);
            break;
          default:
            break;
        }
      }

      if (Array.isArray(value)) {
        const valuesOnly = value.map((v) => v.value);
        const labelsOnly = value.map((v) => v.label);

        switch (key) {
          case "Brand":
            formData.append("brand_id", valuesOnly.join("|"));
            break;
          case "Size":
            formData.append("size_id", valuesOnly.join("|"));
            break;
          case "Manufacturers":
            formData.append("manufacturer_name", labelsOnly.join("|"));
            break;
          case "Material":
            formData.append("material_name", labelsOnly.join("|"));
            break;
          case "Firmness":
            formData.append("firmness_type", labelsOnly.join("|"));
            break;
          case "Color":
            formData.append("color_name", labelsOnly.join("|"));
            break;
          case "Out of stock":
            if (valuesOnly.includes(true)) {
              formData.append("out_of_stock", true);
            }
            break;
          case "Discount":
            if (labelsOnly.length) {
              const maxDiscount = parseInt(labelsOnly[0]);
              formData.append("min_discount", 0);
              formData.append("max_discount", maxDiscount);
            }
            break;
          case "Moq":
            if (labelsOnly.length) {
              formData.append("moq", labelsOnly[0]);
            }
            break;
          default:
            break;
        }
      }
    });

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_filter_products`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status === 1) {
        const data3 = response.data.get_admin_filter_product_lists;
        if (data3) {
          const mappedProducts = mapProductData(data3);
          setProducts(mappedProducts);
        }
      } else {
        setProducts([]);

      }
    } catch (error) {
      console.error("Error applying filters:", error);

    } finally {
      setIsLoading(false);
    }
  };

  const handleClearFilters = () => {
    setSelectedOptions({
      expandedSections: selectedOptions.expandedSections,
    });
    setSortOption("Price: Low to High"); // Reset sort option
    setProducts([]);
    onResetFilters?.();
  };



  return (
    <div className={`relative flex ${webFont}`}>
      <style>
        {`
          @keyframes vibrate {
            0% { transform: translate(0); }
            20% { transform: translate(-2px, 2px); }
            40% { transform: translate(-2px, -2px); }
            60% { transform: translate(2px, 2px); }
            80% { transform: translate(2px, -2px); }
            100% { transform: translate(0); }
          }
          .vibrate {
            animation: vibrate 0.3s linear;
          }
        `}
      </style>
      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 w-72 h-screen md:h-[calc(100vh-2rem)] bg-white transform z-40 ${isOpen ? "translate-x-0" : "-translate-x-full"
          }  md:sticky md:translate-x-0 transition-transform duration-300 ease-in-out md:w-1/4`}

      // style={{
      //   scrollbarWidth: "none",          // Firefox
      //   msOverflowStyle: "none",         // IE 10+
      // }}
      >
        {/* Hide scrollbar in WebKit browsers */}
        <style>
          {`
          div::-webkit-scrollbar {
            display: none;
          }
        `}
        </style>
        <button className="p-4 md:hidden" onClick={() => setIsOpen(false)}>
          <FiX size={24} />
        </button>
        <div className="z-10 h-full p-4 pt-0 overflow-y-auto">
          <div className="sticky top-0 z-50 p-3 bg-white border-b md:p-4">
            <h2 className="flex flex-col gap-3 text-lg font-semibold md:flex-row md:items-center md:justify-between md:text-2xl">

              {/* Title */}
              <span className="flex items-center gap-2">
                <PiSlidersHorizontal />
                Filters
              </span>

              {/* Buttons */}
              <div className="flex w-full gap-2 md:w-auto">
                <button
                  className="flex-1 py-1 text-sm text-gray-600 border rounded md:flex-none md:border-0 hover:underline"
                  onClick={applyFilters}
                  disabled={isLoading}
                >
                  {isLoading ? "Applying..." : "Apply"}
                </button>

                <button
                  className="flex-1 py-1 text-sm text-gray-600 border rounded md:flex-none md:border-0 hover:underline"
                  onClick={handleClearFilters}
                >
                  Clear All
                </button>
              </div>

            </h2>
          </div>

          {filters.map((filter) => (
            <div key={filter.title} className="pb-4 mb-4 border-b">
              <div
                className="flex items-center justify-between font-medium cursor-pointer"
                onClick={() =>
                  setSelectedOptions((prev) => ({
                    ...prev,
                    expandedSections: {
                      ...prev.expandedSections,
                      [filter.title]: !prev.expandedSections?.[filter.title],
                    },
                  }))
                }
              >
                <span>{filter.title}</span>
                {selectedOptions.expandedSections?.[filter.title] ? (
                  <FiChevronUp />
                ) : (
                  <FiChevronDown />
                )}
              </div>

              {!selectedOptions.expandedSections?.[filter.title] && (
                <div className="mt-1 text-sm text-gray-600">
                  {filter.type === "slider" || filter.type === "dimension-group"
                    ? filter.type === "slider"
                      ? `${selectedOptions[filter.title]?.min ??
                      filter.sliderRange?.min ??
                      0
                      } - ${selectedOptions[filter.title]?.max ??
                      filter.sliderRange?.max ??
                      100
                      }`
                      : filter.options
                        .map(
                          (dim) =>
                            `${dim.name}: ${selectedOptions[`${filter.title}-${dim.name}`]
                              ?.min ?? 0
                            } - ${selectedOptions[`${filter.title}-${dim.name}`]
                              ?.max ?? 100
                            }`
                        )
                        .join(", ")
                    : selectedOptions[filter.title]?.length > 0
                      ? selectedOptions[filter.title]
                        .map((opt) => opt.label)
                        .join(", ")
                      : "All"}
                </div>
              )}

              {selectedOptions.expandedSections?.[filter.title] && (
                <div className="mt-3 space-y-4">
                  {filter.type === "dimension-group" ? (
                    filter.options.map((dim) => {
                      const dimKey = `${filter.title}-${dim.name}`;
                      const min = 0;
                      const max = 100;
                      const values = [
                        selectedOptions[dimKey]?.min ?? min,
                        selectedOptions[dimKey]?.max ?? max,
                      ];

                      return (
                        <div key={dimKey}>
                          <label className="block mb-1 text-sm font-medium">
                            {dim.name}
                          </label>
                          <div className="flex justify-between mb-1 text-xs">
                            <span>{values[0]}</span>
                            <span>{values[1]}</span>
                          </div>
                          <ReactSlider
                            className="horizontal-slider"
                            thumbClassName="h-4 w-4 bg-blue-600 rounded-full cursor-pointer"
                            trackClassName="bg-gray-300 h-4 rounded-lg"
                            min={min}
                            max={max}
                            step={1}
                            value={values}
                            onChange={([newMin, newMax]) =>
                              setSelectedOptions((prev) => ({
                                ...prev,
                                [dimKey]: { min: newMin, max: newMax },
                              }))
                            }
                            withTracks
                            pearling
                            minDistance={1}
                          />
                        </div>
                      );
                    })
                  ) : filter.type === "slider" ? (
                    <>
                      <div className="flex justify-between mb-1 text-xs">
                        <span>
                          {selectedOptions[filter.title]?.min ??
                            filter.sliderRange?.min ??
                            0}
                        </span>
                        <span>
                          {selectedOptions[filter.title]?.max ??
                            filter.sliderRange?.max ??
                            100}
                        </span>
                      </div>
                      <ReactSlider
                        className="horizontal-slider"
                        thumbClassName="h-4 w-4 bg-blue-600 rounded-full cursor-pointer"
                        trackClassName="bg-gray-300 h-4 rounded-lg"
                        min={filter.sliderRange?.min ?? 0}
                        max={filter.sliderRange?.max ?? 100}
                        step={1}
                        value={[
                          selectedOptions[filter.title]?.min ??
                          filter.sliderRange?.min ??
                          0,
                          selectedOptions[filter.title]?.max ??
                          filter.sliderRange?.max ??
                          100,
                        ]}
                        onChange={([newMin, newMax]) =>
                          setSelectedOptions((prev) => ({
                            ...prev,
                            [filter.title]: { min: newMin, max: newMax },
                          }))
                        }
                        withTracks
                        pearling
                        minDistance={1}
                      />
                    </>
                  ) : (
                    filter.options.map((option) => (
                      <label
                        key={option.value}
                        className="flex items-center space-x-2 text-gray-700"
                      >
                        <input
                          type="checkbox"
                          className="form-checkbox"
                          checked={
                            selectedOptions[filter.title]?.some(
                              (o) => o.value === option.value
                            ) || false
                          }
                          onChange={() => {
                            setSelectedOptions((prev) => {
                              const prevOptions = prev[filter.title] || [];
                              if (
                                filter.title === "Moq" ||
                                filter.title === "Discount"
                              ) {
                                // Single selection: toggle or select new option
                                const exists = prevOptions.some(
                                  (o) => o.value === option.value
                                );
                                return {
                                  ...prev,
                                  [filter.title]: exists ? [] : [option],
                                };
                              } else {
                                // Multiple selection: add or remove option
                                const exists = prevOptions.some(
                                  (o) => o.value === option.value
                                );
                                return {
                                  ...prev,
                                  [filter.title]: exists
                                    ? prevOptions.filter(
                                      (o) => o.value !== option.value
                                    )
                                    : [...prevOptions, option],
                                };
                              }
                            });
                          }}
                        />
                        <span>{option.label}</span>
                      </label>
                    ))
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0 px-2 py-1 overflow-hidden md:ml-3 md:mr-8">


        <p className="flex items-center justify-between mt-4 font-bold">
          <div>
            Buy{" "}
            {Object.keys(selectedOptions).some(
              (key) =>
                key !== "expandedSections" && selectedOptions[key]?.length > 0
            )
              ? ""
              : subcategoryName}{" "}
            Online
            <span className="text-sm font-semibold text-gray-500">
              (Showing {displayCount} products)
            </span>

          </div>

          <div className="relative hidden sm:block">
            <button
              onClick={toggleDropdown}
              className="flex items-center justify-between p-2 border border-t-0 rounded-sm w-80 h-14"
            >
              <span className="mr-2 font-normal">Sort By: {sortOption}</span>
              {isOpen2 ? <SlArrowUp size={12} /> : <SlArrowDown size={12} />}
            </button>
            {isOpen2 && (
              <div className="absolute right-0 bg-white border border-t-0 rounded-sm shadow-md w-80">
                <ul className="px-0 py-2">
                  {["Price: Low to High", "Price: High to Low", "New Arrivals", "Discounts"].map((option) => (
                    <li
                      key={option}
                      className="px-2 py-2 font-normal cursor-pointer hover:bg-gray-200"
                      onClick={() => {
                        setSortOption(option);
                        setIsOpen2(false);
                      }}
                    >
                      {option}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </p>
        <div className="flex items-center justify-between m-2 border-t border-b md:hidden">
          <div className="flex items-center justify-center border-r ml-14">
            <button
              className="flex items-center justify-center p-2 mr-5 font-bold md:hidden"
              onClick={() => setIsOpen(true)}
            >
              <PiSlidersHorizontal size={24} /> Filters
            </button>
          </div>

          <div className="relative flex items-center justify-center mr-2 md:hidden">
            <button
              onClick={toggleDropdown2}
              className="flex items-center justify-start w-40 p-2 ml-5 rounded-sm h-14"
            >
              <span className="flex flex-col mr-2 font-bold leading-tight">
                Sort By
                {sortOption && (
                  <span className="text-sm font-normal text-gray-500">
                    {sortOption}
                  </span>
                )}
              </span>

              {isOpen3 ? <SlArrowUp size={12} /> : <SlArrowDown size={12} />}
            </button>

            {isOpen3 && (
              <div className="absolute right-0 z-50 w-40 bg-white rounded-sm shadow-md top-16">
                <ul className="px-0 py-2">
                  {["Price: Low to High", "Price: High to Low", "New Arrivals", "Discounts"].map((option) => (
                    <li
                      key={option}
                      className="px-2 py-2 font-normal cursor-pointer hover:bg-gray-200"
                      onClick={() => {
                        setSortOption(option);
                        setIsOpen3(false);
                      }}
                    >
                      {option}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
        <div className="max-w-6xl pt-3 mx-auto">  

          {/* 👉 NO PRODUCTS MESSAGE */}
          {!isLoading && products.length === 0 && (
            <div className="flex flex-col items-center justify-center py-20 text-center">
              <img
                src="https://cdn-icons-png.flaticon.com/512/4076/4076549.png"
                alt="No products"
                className="w-32 h-32 mb-4 opacity-70"
              />
              <h2 className="text-lg font-semibold text-gray-700">
                No products available
              </h2>
              <p className="mt-1 text-sm text-gray-500">
                Try adjusting or clearing filters
              </p>
            </div>
          )}

          {/* 👉 PRODUCT LIST */}
          {products.length > 0 &&
            products.map((product) => (
              <div key={product.product_auto_id}>

                {/* ================= MOBILE VIEW ================= */}
                <div
                  className="flex flex-col p-4 mb-4 bg-white border cursor-pointer md:hidden rounded-3xl"
                  onClick={() => navigate(`/product-detail/${product.product_auto_id}`)}
                >

                  {/* IMAGE + NAME SIDE BY SIDE */}
                  <div className="flex">

                    {/* Image box */}
                    <div className="relative flex items-center justify-center w-32 h-32 pt-4 mr-4 bg-white border rounded-xl">
                      <div className="absolute top-0 left-0 flex space-x-2 whitespace-nowrap">
                        {product.badge && (
                          <span className="px-1 py-0.5 text-[10px] text-white bg-black rounded-lg">
                            {product.badge}
                          </span>
                        )}
                        {product.bought && (
                          <span className="pl-1 py-0.5 text-[10px] font-semibold bg-white border rounded-lg">
                            {product.bought}
                          </span>
                        )}
                      </div>

                      <img
                        src={product.image}
                        alt={product.name}
                        className="object-contain w-full h-full"
                      />
                    </div>

                    {/* Title + Rating */}
                    <div className="flex flex-col flex-1">
                      <h2 className="text-sm font-semibold leading-tight line-clamp-2">
                        {product.name}
                      </h2>

                      {/* <p className="mt-1 text-xs text-gray-600">Compare</p> */}

                      {/* Rating */}
                      {/* <div className="flex mt-2 text-lg text-yellow-500">
              {[...Array(product.rating)].map((_, index) => (
                <MdOutlineStarPurple500 key={index} />
              ))}
            </div> */}
                      {/* FEATURES */}
                      <p className="text-xs text-gray-700 line-clamp-2">
                        {product.features.join(" | ")}
                      </p>


                      {/* PRICE SECTION */}
                      <div className="pl-6 mt-0">
                        <p className="text-xl font-bold text-black">{product.price}</p>

                        <div className="flex items-center mt-1 space-x-2">
                          <p
                            className="text-xs text-gray-500 line-through"
                            style={{
                              visibility:
                                product.discount &&
                                  parseFloat(product.discount.replace("% off", "")) > 0
                                  ? "visible"
                                  : "hidden",
                            }}
                          >
                            {product.originalPrice}
                          </p>

                          <p
                            className="px-2 py-1 text-xs font-semibold text-white rounded-full"
                            style={{
                              backgroundColor: themeColor,
                              visibility:
                                product.discount &&
                                  parseFloat(product.discount.replace("% off", "")) > 0
                                  ? "visible"
                                  : "hidden",
                            }}
                          >
                            {product.discount}
                          </p>
                        </div>
                      </div>

                    </div>
                  </div>

                  {/* FEATURES
        <ul className="flex flex-wrap gap-1 mt-3 text-xs text-gray-700">
          {product.features.map((feature, index) => (
            <li key={index} className="after:content-['|'] after:mx-1 last:after:content-none">
              {feature}
            </li>
          ))}
        </ul> */}

                  <div className="flex items-center justify-between w-full">
                    {/* LEFT: DELIVERY (More width) */}
                    <div className="flex w-[65%] items-center text-sm text-gray-700">
                      <FiTruck className="mr-2 text-gray-600" />
                      Free delivery by{" "}
                      <span className="ml-1 font-medium">{product.delivery}</span>
                    </div>

                    {/* RIGHT: BUTTONS (Smaller width) */}
                    <div className="flex w-[35%] items-center justify-end gap-2">

                      {/* Wishlist */}
                      <button
                        className={`p-2 border rounded-full ${vibratingHearts[product.id] ? "vibrate" : ""
                          }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleFavorite(product.id, product.product_auto_id);
                        }}
                      >
                        {favorites[product.id] ? (
                          <FaHeart className="text-xl text-red-500" />
                        ) : (
                          <FaRegHeart className="text-xl text-gray-600" />
                        )}
                      </button>

                      {/* Add to Cart */}
                      <button
                        className={`flex items-center justify-center gap-1 px-3 py-2 bg-black text-white text-sm font-semibold rounded-full ${vibratingCarts[product.id] ? "vibrate" : ""
                          }`}
                        onClick={async (e) => {
                          e.stopPropagation();
                          const payload = {
                            product_auto_id: product?.product_auto_id,
                            added_by_id: product?.user_auto_id,
                            cart_quantity:
                              product?.moq && product.moq !== "" ? product.moq : 1,
                          };
                          try {
                            const res = await addToCart(payload);
                            if (res.status === "1") {
                              setCartMessages(prev => ({
                                ...prev,
                                [product.product_auto_id]: ""
                              }));
                              setTimeout(() => navigate("/cart"), 1000);
                            } else if (
                              res.status === "0" &&
                              res.msg === "Product already added in cart"
                            ) {
                              setCartMessages(prev => ({
                                ...prev,
                                [product.product_auto_id]: res.message
                              }));

                              setVibratingCarts((prev) => ({
                                ...prev,
                                [product.id]: true,
                              }));
                              setTimeout(
                                () =>
                                  setVibratingCarts((prev) => ({
                                    ...prev,
                                    [product.id]: false,
                                  })),
                                500
                              );
                            } else {
                              throw new Error(res.message);
                            }
                          } catch (error) {
                            setVibratingCarts((prev) => ({
                              ...prev,
                              [product.id]: true,
                            }));
                            setTimeout(() => {
                              setVibratingCarts((prev) => ({
                                ...prev,
                                [product.id]: false,
                              }));
                              if (error.message === "Please log in first.") {
                                openLoginModal();
                              }
                            }, 500);
                          }
                        }}
                      >
                        <PiShoppingCartLight className="text-lg" />
                        Add
                      </button>
                      {cartMessages[product.product_auto_id] && (
                        <p className="mt-1 text-xs text-red-500">
                          {cartMessages[product.product_auto_id]}
                        </p>
                      )}

                    </div>
                  </div>

                </div>

                {/* ================= DESKTOP VIEW (YOUR ORIGINAL) ================= */}
                <div
                  className="flex-row hidden p-3 mb-4 bg-white border cursor-pointer md:flex rounded-3xl min-h-80"
                  onClick={() => navigate(`/product-detail/${product.product_auto_id}`)}
                >
                  {/* Leave your original desktop code here */}
                  <div className="relative flex items-center justify-center w-28 h-28 md:w-1/4 md:h-auto">
                    {/* Badges */}
                    <div className="absolute flex gap-8 space-x-2 top-2 left-2">
                      {product.badge && (
                        <span className="px-2 py-1 text-xs text-white bg-black rounded-full">
                          {product.badge}
                        </span>
                      )}
                      {product.bought && (
                        <span className="px-2 py-1 text-xs font-semibold bg-white border rounded-full">
                          {product.bought}
                        </span>
                      )}
                    </div>

                    <img
                      src={product.image}
                      alt={product.name}
                      className="rounded-lg w-38 h-38 object-contain md:w-40 md:h-[200px]"
                    />
                  </div>

                  {/* Middle Section - Product Details */}
                  <div className="flex-1 px-2 mt-2 md:px-4 md:mt-0">
                    <h2 className="text-sm font-semibold md:text-lg line-clamp-2">
                      {product.name}
                    </h2>

                    <div className="flex mt-1 text-lg text-yellow-500 md:text-2xl">
                      {[...Array(Math.floor(Number(product.rating) || 0))].map((_, index) => (
                        <MdOutlineStarPurple500 key={index} />
                      ))}

                    </div>

                    <ul className="pl-0 mt-1 text-xs text-gray-600 md:text-sm">
                      {product.features.map((feature, index) => (
                        <li key={index}>• {feature}</li>
                      ))}
                    </ul>
                  </div>

                  {/* Right Section - Price & Actions */}
                  <div className="flex flex-col items-start w-full pl-0 mt-3 md:w-1/4 md:mt-0 md:pl-11 md:border-l">
                    <p className="text-lg font-bold text-black md:text-2xl">
                      {product.price}
                    </p>

                    <div className="flex items-center space-x-2">
                      <p
                        className="text-xs text-gray-500 line-through md:text-sm"
                        style={{
                          visibility:
                            product.discount &&
                              parseFloat(product.discount.replace('% off', '')) > 0
                              ? 'visible'
                              : 'hidden',
                        }}
                      >
                        {product.originalPrice}
                      </p>
                      <p
                        className="px-2 py-1 text-xs font-semibold text-white rounded-full md:text-sm"
                        style={{
                          backgroundColor: themeColor,
                          visibility:
                            product.discount &&
                              parseFloat(product.discount.replace('% off', '')) > 0
                              ? 'visible'
                              : 'hidden',
                        }}
                      >
                        {product.discount}
                      </p>
                    </div>

                    <div className="flex items-center mt-3 text-xs text-gray-600 md:text-sm">
                      <FiTruck className="mr-2 text-gray-500" /> Delivery by
                      <span className="ml-1">{product.delivery}</span>
                    </div>

                    <div className="flex mt-2 space-x-3">
                      <button
                        className={`p-2 border rounded-full ${vibratingHearts[product.id] ? 'vibrate' : ''
                          }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleFavorite(product.id, product.product_auto_id);
                        }}
                      >
                        {favorites[product.id] ? (
                          <FaHeart className="text-xl text-red-500" />
                        ) : (
                          <FaRegHeart className="text-xl text-gray-600" />
                        )}
                      </button>

                      <button
                        className={`p-2 bg-black rounded-full ${vibratingCarts[product.id] ? 'vibrate' : ''
                          }`}
                        onClick={async (e) => {
                          e.stopPropagation();
                          const payload = {
                            product_auto_id: product?.product_auto_id,
                            added_by_id: product?.user_auto_id,
                            cart_quantity:
                              product?.moq && product.moq !== '' ? product.moq : 1,
                          };
                          try {
                            const res = await addToCart(payload);
                            if (res.status === '1') {
                              setCartMessages(prev => ({
                                ...prev,
                                [product.product_auto_id]: ""
                              }));
                              setTimeout(() => navigate('/cart'), 1000);
                            } else if (
                              res.status === '0' &&
                              res.msg === 'Product already added in cart'
                            ) {
                              setCartMessages(prev => ({
                                ...prev,
                                [product.product_auto_id]: res.message
                              }));
                              setVibratingCarts((prev) => ({ ...prev, [product.id]: true }));
                              setTimeout(
                                () =>
                                  setVibratingCarts((prev) => ({
                                    ...prev,
                                    [product.id]: false,
                                  })),
                                500
                              );
                            } else {
                              throw new Error(res.message);
                            }
                          } catch (error) {
                            setVibratingCarts((prev) => ({ ...prev, [product.id]: true }));
                            setTimeout(() => {
                              setVibratingCarts((prev) => ({
                                ...prev,
                                [product.id]: false,
                              }));
                              if (error.message === 'Please log in first.') {
                                openLoginModal();
                              }
                            }, 500);
                          }
                        }}
                      >
                        <PiShoppingCartLight className="text-white" />
                      </button>

                    </div>
                    {cartMessages[product.product_auto_id] && (
                      <p className="mt-1 text-xs text-red-500">
                        {cartMessages[product.product_auto_id]}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}
        </div>


      </div>
      {isLoginModalOpen && <Login isOpen={isLoginModalOpen} onClose={closeLoginModal} />}
    </div>
  );
};

export default ProductList12;
